module.exports = __webpack_public_path__ + "files/f3767bbb6442f16510cdc8b77b3169d9.png";